import { Link, useNavigate, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import Sidebar from "./sidebar";
import { Check, CheckCircle, Plus } from "react-feather";
import React, { useState, useEffect } from "react";
import api from "../api";

function SellerWithdraw() {
    const baseUrl = process.env.REACT_APP_BASE_URL;
    const navigate = useNavigate();
    const location = useLocation();
    const token = localStorage.getItem("access_token");

    // Only relevant states
    const [pymtFormData, setPymtFormData] = useState({
        bank_code: "",
        pay_mode_desc: "",
        pay_mode_desc_paybill: "",
        acc_no: "",
    });

    const [pymtFormData0, setPymtFormData0] = useState({
        bank_code: "",
        pay_mode_desc: "",
        pay_mode_desc_paybill: "",
        acc_no: "",
    });

    const [selectedBankIntasend, setSelectedBankIntasend] = useState("");
    const [selectedBankIntasendCode, setSelectedBankIntasendCode] = useState("MPESA");

    // Validation div toggles
    const [PayDiv1, setPayDiv1] = useState(false);
    const [PayDiv2, setPayDiv2] = useState(false);
    const [PayDiv3, setPayDiv3] = useState(false);
    const [PayDiv4, setPayDiv4] = useState(false);

    const [PayDetail1, setPayDetail1] = useState(true);
    const [PayConfirm, setPayConfirm] = useState(false);
    const [paymethodconfirm, setpaymethodconfirm] = useState("");
    

    const [csrfToken, setCsrfToken] = useState("");

    // Hardcoded bank list
    const banksIntasend = [
        { bank_name: "KCB", bank_code: "1", bank_paybill: "522522" },
        { bank_name: "NCBA", bank_code: "7", bank_paybill: "880100" },
        { bank_name: "Equity Bank", bank_code: "68", bank_paybill: "247247" },
        { bank_name: "Cooperative Bank", bank_code: "11", bank_paybill: "400200" },
        { bank_name: "DTB", bank_code: "63", bank_paybill: "516600" },
        { bank_name: "Family Bank", bank_code: "70", bank_paybill: "222111" },
        { bank_name: "I&M Bank", bank_code: "57", bank_paybill: "542542" },
        { bank_name: "Stanbic Bank", bank_code: "31", bank_paybill: "600100" },
    ];

    useEffect(() => {
        fetchCsrf();
        fetchExistingAccount();
    }, []);

    const fetchCsrf = async () => {
        try {
            const response = await api.get(`${baseUrl}/get-csrf-token/`, { withCredentials: true });
            setCsrfToken(response.data.csrfToken);
        } catch {}
    };

    const fetchExistingAccount = async () => {
        try {
            const response = await api.get("/vendor/", {
                headers: { Authorization: `Bearer ${token}` },
            });

            setPymtFormData0({
                bank_code: response.data.bank_code,
                pay_mode_desc: response.data.pay_mode_desc,
                pay_mode_desc_paybill: response.data.pay_mode_desc_paybill,
                acc_no: response.data.acc_no,
            });
        } catch {}
    };

    const getVendorCurrency = () => {
        return localStorage.getItem("VendorCurrency");
    };

    const bankinputHandler = (e) => {
        const fullValue = e.target.value;
        const parts = fullValue.split(" - ");
        setSelectedBankIntasend(parts[0]);
        setSelectedBankIntasendCode(parts[1]);
    };

    const inputHandler = (event) => {
        setPymtFormData({
            ...pymtFormData,
            [event.target.name]: event.target.value,
        });
    };

    const submitHandlerBack = async () => {       

        setPayDetail1(true);
        setPayConfirm(false);

    };

    const submitHandlerCheck = async () => {
        if (pymtFormData.pay_mode_desc === "") {
            setPayDiv1(true);
            return;
        }

        if (pymtFormData.pay_mode_desc === "Bank" && selectedBankIntasend.length < 3) {
            setPayDiv2(true);
            return;
        }

        if (pymtFormData.acc_no.length < 5) {
            setPayDiv3(true);
            return;
        }

        if (pymtFormData.pay_mode_desc === "Bank") {
            setpaymethodconfirm(selectedBankIntasend);
        }

        if(pymtFormData.pay_mode_desc === "Mpesa"){
            setpaymethodconfirm("Mpesa");
        }

        setPayDetail1(false);
        setPayConfirm(true);

    };

    const submitHandler = async () => {
        setPayDetail1(false);
        setPayConfirm(true);
        let paybill = 0;

        if (pymtFormData.pay_mode_desc === "") {
            setPayDiv1(true);
            return;
        }

        if (pymtFormData.pay_mode_desc === "Bank" && selectedBankIntasend.length < 3) {
            setPayDiv2(true);
            return;
        }

        if (pymtFormData.acc_no.length < 5) {
            setPayDiv3(true);
            return;
        }

        if (pymtFormData.pay_mode_desc === "Bank") {
            paybill = selectedBankIntasend;
        }

        const formData = new FormData();
        formData.append("bank_code", selectedBankIntasendCode);
        formData.append("pay_mode_desc", pymtFormData.pay_mode_desc);
        formData.append("pay_mode_desc_paybill", paybill);
        formData.append("acc_no", pymtFormData.acc_no);

        try {
            const response = await api.patch("/vendor/", formData, {
                headers: { Authorization: `Bearer ${token}` },
            });

            setPayDiv4(true);

            setPymtFormData0({
                pay_mode_desc: response.data.pay_mode_desc,
                pay_mode_desc_paybill: response.data.pay_mode_desc_paybill,
                acc_no: response.data.acc_no,
            });

            setTimeout(() => {
                window.location.href = "/seller/setup";
            }, 3000);
        } catch {}
    };

    return (
        <>
            <Helmet>
                <title>Finance - Account Details</title>
                <meta name="description" content="Finance - Account Details" />
            </Helmet>

            <section className="container mtopcon dashb">
                <div className="row">

                    {/* Sidebar */}
                    <div className="col-12 col-lg-2 dash-min mb-3">
                        <div className="nav-left-sidebar sidebar-dark pc">
                            <nav className="navbar navbar-expand-lg navbar-light nav-l-con">
                                <div className="collapse navbar-collapse" id="navbarNav">
                                    <Sidebar />
                                </div>
                            </nav>
                        </div>
                    </div>

                    {/* Main Content */}
                    <div className="col-12 col-lg-10 dash-max">

                        <div className="row mb-4 ph-header-con">
                            <h6 className="pageheader-title mb-0">Account Details</h6>
                            <p className="grey-text lh0 font8">
                                Set the account where your earnings will be settled.
                            </p>
                        </div>

                        <div className="row d-flex justify-content-center mt-4">
                            <div className="col-12 col-lg-4">
                                <div className="card shadow-sm border border-secondary border-opacity-10">

                                    {/* Existing account */}
                                    {pymtFormData0.acc_no !== "" && pymtFormData0.acc_no !== null ? (
                                        <>
                                            <div className="card-header font9">
                                                <p className="ms-3"><b>Account Details</b></p>
                                            </div>

                                            <div className="card-body pt-1">

                                                <div className="grey-text font9 mb-2 mt-2">Existing settlement account</div>

                                                {/* Mpesa */}
                                                {pymtFormData0.pay_mode_desc === "Mpesa" && (
                                                    <div className="row ord-bg bg-white hvr bx-shadow font8 acc-con">
                                                        <div className="col-1">-</div>
                                                        <div className="col-4 p-0">Mpesa</div>
                                                        <div className="col-5 p-0">{pymtFormData0.acc_no}</div>
                                                        <div className="col-2">
                                                            <CheckCircle className="text-success" />
                                                        </div>
                                                    </div>
                                                )}

                                                {/* Bank */}
                                                {pymtFormData0.pay_mode_desc === "Bank" && (
                                                    <div className="row ord-bg bg-white hvr bx-shadow font8 acc-con">
                                                        <div className="col-1">-</div>
                                                        <div className="col-3 p-0">Bank</div>
                                                        <div className="col-4 p-0">{pymtFormData0.pay_mode_desc_paybill}</div>
                                                        <div className="col-3 p-0">{pymtFormData0.acc_no}</div>
                                                        <div className="col-1">
                                                            <CheckCircle className="text-success" />
                                                        </div>
                                                    </div>
                                                )}

                                                <p className="grey-text font8 mt-4 mb-0">
                                                    To update your account details, kindly contact support at{" "}
                                                    <Link to="mailto:accounts@kadhr.com">accounts@kadhr.com</Link>
                                                </p>

                                                <hr />

                                                {/* Transaction Fees */}
                                                <div className="accordion accordion-flush mt-2 bg-white br-10" id="feesAccordion">
                                                    <div className="accordion-item">
                                                        <h6 className="accordion-header">
                                                            <button
                                                                className="accordion-button collapsed grey-text p-0 font8"
                                                                type="button"
                                                                data-bs-toggle="collapse"
                                                                data-bs-target="#fees"
                                                            >
                                                                View transaction fees
                                                            </button>
                                                        </h6>

                                                        <div id="fees" className="accordion-collapse collapse mt-3">
                                                            <div className="accordion-body font8 p-0 mt-2 wthdrwtbl">
                                                                <table className="table table-bordered rounded-3">
                                                                    <thead className="table-light">
                                                                        <tr>
                                                                            <th>#</th>
                                                                            <th>Min (KES)</th>
                                                                            <th>Max (KES)</th>
                                                                            <th>Charge ({getVendorCurrency()})</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        <tr className="table-secondary">
                                                                            <th colSpan="5">Transfers to M-PESA</th>
                                                                        </tr>
                                                                        <tr><td>1</td><td>1</td><td>1500</td><td>20</td></tr>
                                                                        <tr><td>2</td><td>1501</td><td>20000</td><td>40</td></tr>
                                                                        <tr><td>3</td><td>20001</td><td>Above</td><td>60</td></tr>

                                                                        <tr className="table-secondary">
                                                                            <th colSpan="5">Transfers to Bank</th>
                                                                        </tr>
                                                                        <tr><td>1</td><td>1</td><td>10000</td><td>80</td></tr>
                                                                        <tr><td>2</td><td>10001</td><td>50000</td><td>120</td></tr>
                                                                        <tr><td>3</td><td>50001</td><td>999999</td><td>140</td></tr>
                                                                        <tr><td>4</td><td>1000001</td><td>Above</td><td>350</td></tr>
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                    ) : (
                                        <button
                                            type="button"
                                            className="col-12 btn btn-success addpymt"
                                            data-bs-toggle="modal"
                                            data-bs-target="#addaccount"
                                        >
                                            <Plus /> Add Payment Details
                                        </button>
                                    )}


                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Add Account Modal */}
                <div className="modal fade" id="addaccount" tabIndex="-1">
                    <div className="modal-dialog mt70">
                        <div className="modal-content">
                            <div className="modal-body pb-4">
                                {PayDetail1==true && <>
                                    <h6><b>Update Payment Details</b></h6>

                                    <label className="form-label mb-0 font9 mt-3">Account Type</label>
                                    <select className="form-control font9 ht40" onChange={inputHandler} name="pay_mode_desc">
                                        <option value="">Select</option>
                                        <option value="Mpesa">Mpesa</option>
                                        <option value="Bank">Bank</option>
                                    </select>
                                    {PayDiv1 && <p className="text-danger font9">*Confirm this value</p>}

                                    {pymtFormData.pay_mode_desc === "Bank" && (
                                        <>
                                            <label className="font9 mt-3 grey-text">Bank Name</label>

                                            <select className="form-control font9 ht40" onChange={bankinputHandler}>
                                                <option value="">-- Select a Bank --</option>
                                                {banksIntasend.map((bank, idx) => (
                                                    <option key={idx} value={`${bank.bank_name} - ${bank.bank_code}`}>
                                                        {bank.bank_name}
                                                    </option>
                                                ))}
                                            </select>

                                            {PayDiv2 && <p className="text-danger font9">*Confirm Paybill</p>}
                                        </>
                                    )}

                                    <label className="font9 mt-3 grey-text">
                                        {pymtFormData.pay_mode_desc === "Bank" ? "Account Number" : "Mpesa Number"}
                                    </label>

                                    <input
                                        type="number"
                                        className="form-control font9 ht40"
                                        name="acc_no"
                                        onChange={inputHandler}
                                    />

                                    {PayDiv3 && <p className="text-danger font9">*Confirm this value</p>}

                                    <button
                                        type="button"
                                        className="btn btn-primary col-12 mt-4 pb-2 pt-2 br50r"
                                        onClick={submitHandlerCheck}
                                    >
                                        Complete
                                    </button>
                                </>}

                                {PayConfirm==true &&<>                                        
                                    <div className="d-flex justify-content-center align-items-center bg-light br10">
                                        <div className="text-center w-100 p-4">
                                            
                                            {/* Success Icon */}
                                            <div className="success-icon mx-auto mb-3">
                                                <Check size={30} />
                                            </div>

                                            {/* Title */}
                                            <h5 className="fw-bold mb-4">
                                                Confirm Payment Details
                                            </h5>

                                            {/* Order details */}
                                            <div className="order-details text-start mb-4">

                                                <div className="d-flex justify-content-between">
                                                    <span className="text-muted small">Payment Method</span>
                                                    <span className="fw-semibold">{paymethodconfirm}</span>
                                                </div>
                                                <hr />

                                                <div className="d-flex justify-content-between">
                                                    <span className="text-muted small">Account</span>
                                                    <span className="fw-semibold">{pymtFormData.acc_no}</span>
                                                </div>
                                            </div>

                                            {/* CTA */}
                                            <p className="text-left text-primary font-bold mb-2 w-100 rounded-pill py-2 pointer" onClick={submitHandlerBack}>
                                                Edit Details
                                            </p>
                                            <button className="btn btn-dark w-100 rounded-pill py-2" onClick={submitHandler}>
                                                Complete
                                            </button>
                                        </div>
                                    </div>
                                </>}

                                {PayDiv4 && <p className="text-success mt-4 text-center"><b>Account details updated successfully, redirecting...</b></p>}
                            </div>
                        </div>
                    </div>
                </div>

            </section>
        </>
    );
}

export default SellerWithdraw;
